import Input from 'components/Inputs/Input';
import Devices from 'types/Devices';
import { TitleInputInfo } from 'types/InputInfo';
import { useTranslation } from 'react-i18next';

type TitleInputProps = {
  value: string,
  onChange: (value: string) => void,
  type: Devices
};

const TitleInput = ({ value, onChange, type }: TitleInputProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Input
      title={ t('form_title_title') }
      restrictions={ TitleInputInfo[type] }
      value={ value }
      onChange={ onChange }
      tooltip={ {
        title: t('tooltip_title_title'),
        description: t('tooltip_title_description')
      } }
    />
  );
};

export default TitleInput;
